module.exports = __webpack_public_path__ + "img/MOUSTACHES 2.2b4b519.svg";